import { render, staticRenderFns } from "./team-chunk.vue?vue&type=template&id=6e689e97&scoped=true&"
import script from "./team-chunk.vue?vue&type=script&lang=js&"
export * from "./team-chunk.vue?vue&type=script&lang=js&"
import style0 from "./team-chunk.vue?vue&type=style&index=0&id=6e689e97&lang=less&scoped=true&"
import style1 from "./team-chunk.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e689e97",
  null
  
)

export default component.exports